import {connect} from 'react-redux';
import BuyNowModal, {BuyNowModalProps} from './BuyNowModal';
import ReduxState from '../../types/ReduxState';
import Config from '../../globals/Config';

const mapStateToProps = (state: ReduxState, ownProps: BuyNowContainerProps): BuyNowModalProps => {
   return {
      themeName: state.themeName,
      onClose: ownProps.onClose,
      storeUrl: Config.storeUrl
   };
};

export default connect(mapStateToProps)(BuyNowModal);

interface BuyNowContainerProps {
   onClose(): void;
}
